export const SUPPORT_BOOK_PATH = '/support/boka-tid';
export const SUPPORT_PAYMENT_PATH = '/support/betalning';
export const SUPPORT_INVOICE_PATH = '/support/faktura';
export const SUPPORT_MY_ACCOUNT_PATH = '/support/mitt-konto';
export const SUPPORT_GIFTCARD_PATH = '/support/presentkort';
export const SUPPORT_BUSINESS_PATH = '/support/foretag';

export const FAQ_ACUPUNCTURE_PATH = '/faq-vanliga-fragor/akupunktur';
export const FAQ_FILLERS_PATH = '/faq-vanliga-fragor/fillers';
export const FAQ_LASHES_PATH = '/faq-vanliga-fragor/kring-fransar';
export const FAQ_SKINCARE_PATH = '/faq-vanliga-fragor/kring-hudvard';
export const FAQ_HAIRCUT_PATH = '/faq-vanliga-fragor/kring-klippning';
export const FAQ_CHIROPRACTIC_PATH = '/faq-vanliga-fragor/kiropraktik';
export const FAQ_MASSAGE_PATH = '/faq-vanliga-fragor/kring-massagebehandlingar';
export const FAQ_NAILS_PATH = '/faq-vanliga-fragor/kring-olika-behandling-for-naglar';

export const faqSupportRoutes = [
  SUPPORT_BOOK_PATH,
  SUPPORT_PAYMENT_PATH,
  SUPPORT_INVOICE_PATH,
  SUPPORT_MY_ACCOUNT_PATH,
  SUPPORT_GIFTCARD_PATH,
  SUPPORT_BUSINESS_PATH,
];
export const faqRoutes = [
  FAQ_ACUPUNCTURE_PATH,
  FAQ_LASHES_PATH,
  FAQ_SKINCARE_PATH,
  FAQ_HAIRCUT_PATH,
  FAQ_CHIROPRACTIC_PATH,
  FAQ_MASSAGE_PATH,
  FAQ_NAILS_PATH,
];
